module.exports = __webpack_public_path__ + "icon-linkedin.png?0d9b55e157135771123729c2ff091651";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-linkedin.png
// module id = 244
// module chunks = 0